import { render, staticRenderFns } from "./waterMaster08Detail.vue?vue&type=template&id=3165e1e3"
import script from "./waterMaster08Detail.vue?vue&type=script&lang=js"
export * from "./waterMaster08Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3165e1e3')) {
      api.createRecord('3165e1e3', component.options)
    } else {
      api.reload('3165e1e3', component.options)
    }
    module.hot.accept("./waterMaster08Detail.vue?vue&type=template&id=3165e1e3", function () {
      api.rerender('3165e1e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/water/mst/waterMaster08Detail.vue"
export default component.exports